import { Card, CardHeader } from "reactstrap";
import { Table, TableRow } from "../../../../components/Table";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { responseToaster } from "../../../../helperFunctions";
import { useRole } from "../../../../redux/slices/authSlice";
import {
  merchantLevelRoaster,
  merchantLevelUpdate,
  setMerchantLevelRoaster,
  useMerchantRoasterLevel,
} from "../../../../redux/slices/merchantSlice";
import ToggleSwitch from "../../../../components/Custom/Forms/ToggleSwitch/ToggleSwitch";
import UpdateRoasters from "./UpdateRoasters";

const LevelRoaster = (props) => {
  const { merchantData } = props;
  const [filterColumns, setFilterColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);

  const role = useRole("Merchant");

  const data = useMerchantRoasterLevel();
  const dispatch = useDispatch();
  const onUpdateStatus = async (payload) => {
    try {
      setStatusLoading(payload?.id);
      await dispatch(merchantLevelUpdate(payload)).unwrap();
      const index = data?.data?.findIndex((item) => item?.id === payload?.id);
      if (index > -1) {
        const newData = [...data?.data];
        newData[index] = { ...newData[index], isActive: payload?.isActive };

        dispatch(
          setMerchantLevelRoaster({
            ...data?.data,
            data: newData,
          })
        );
      }
      setStatusLoading(false);
    } catch (err) {
      setStatusLoading(false);
    }
  };

  const columns = [
    {
      title: "Level Name",
      name: "name"
    },
    {
      title: "amount From",
      name: "amountFrom",
      Cell: (data) => {
        return (
          <>
            {role.includes("merchant-level-roaster-update") ? (
              <UpdateRoasters data={data} dataKey={"amountFrom"} />
            ) : (
              data?.amountFrom
            )}
          </>
        );
      },
    },
    {
      title: "amount to",
      name: "amountTo",
      Cell: (data) => {
        return (
          <>
            {role.includes("merchant-level-roaster-update") ? (
              <UpdateRoasters data={data} dataKey={"amountTo"} />
            ) : (
              data?.amountTo
            )}
          </>
        );
      },
    },
    {
      title: "deposit Count",
      name: "depositCount",
      Cell: (data) => {
        return (
          <>
            {role.includes("merchant-level-roaster-update") ? (
              <UpdateRoasters data={data} dataKey={"depositCount"} />
            ) : (
              data?.depositCount
            )}
          </>
        );
      },
    },
    {
      title: "Active",
      name: "isActive",
      Cell: (data) => {
        return (
          <>
            <ToggleSwitch
              isLoading={statusLoading === data?.id}
              value={data?.isActive ? 1 : 0}
              className={`${statusLoading ? "disabled" : ""}`}
              disabled={!role.includes("merchant-level-roaster-update")}
              onChange={async (value, e) => {
                if (role.includes("merchant-level-roaster-update")) {
                  e.preventDefault();
                  e.stopPropagation();
                  try {
                    const payload = {
                      isActive: value,
                      id: data?.id,
                      merchantId: data?.merchantId,
                    };
                    await onUpdateStatus(payload);
                  } catch (err) { }
                }
              }}
            />
          </>
        );
      },
    },
    {
      title: "withdrawal amount From",
      name: "withdrawalAmtFrom",
      Cell: (data) => {
        return (
          <>
            {role.includes("merchant-level-roaster-update") ? (
              <UpdateRoasters data={data} dataKey={"withdrawalAmtFrom"} />
            ) : (
              data?.withdrawalAmtFrom
            )}
          </>
        );
      },
    },
    {
      title: "withdrawal amount to",
      name: "withdrawalAmtTo",
      Cell: (data) => {
        return (
          <>
            {role.includes("merchant-level-roaster-update") ? (
              <UpdateRoasters data={data} dataKey={"withdrawalAmtTo"} />
            ) : (
              data?.withdrawalAmtTo
            )}
          </>
        );
      },
    },
    {
      title: "withdrawal count",
      name: "withdrawalCount",
      Cell: (data) => {
        return (
          <>
            {role.includes("merchant-level-roaster-update") ? (
              <UpdateRoasters data={data} dataKey={"withdrawalCount"} />
            ) : (
              data?.withdrawalCount
            )}
          </>
        );
      },
    },
  ];
  const onGetData = async () => {
    try {
      setIsLoading(true);
      const clonedPayload = {
        merchantId: merchantData?.merchantId,
      };
      const res = await dispatch(merchantLevelRoaster(clonedPayload)).unwrap();
      if (isFilter) {
        responseToaster(res);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (role.includes("merchant-level-roaster") && merchantData?.merchantId) {
      onGetData();
    }
  }, [merchantData]);

  useEffect(() => {
    const newColumns = columns?.map?.((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  if (!role.includes("merchant-level-roaster")) {
    return;
  }

  return (
    <>
      <div className="merchant-main-div">
        <Card>
          <CardHeader className="flex-column align-items-start">
            <div className="d-flex align-items-center w-100 justify-content-between">
              <h4 className="main-title">
                <b>Merchant Level Roaster</b>
              </h4>
            </div>
          </CardHeader>
          <Table
            columns={columns}
            filterColumns={filterColumns}
            isLoading={isLoading}
            data={data?.data}
            isData={!!data?.data?.length}
            count={data?.total_item || 0}
            isExpandable={false}
            onColumnsChange={(columns) => {
              setFilterColumns(columns);
            }}
          >
            {data?.data?.map((val) => {
              return (
                <TableRow
                  columns={columns}
                  filterColumns={filterColumns}
                  isExpandable={false}
                  item={val}
                />
              );
            })}
          </Table>
        </Card>
      </div>
    </>
  );
};

export default LevelRoaster;
